export default __webpack_public_path__ + "static/media/de-toeff-vom-polizischt.5a203848.png";